import { ICTServerTimeApi } from "@common/ict/api/server-time";
import { BaseAbstractService } from "@common/service/base-service/global";

export class ICTServerTimeService extends BaseAbstractService {
  static getServerTime() {
    return ICTServerTimeApi.getServerTime(this.request).then(res => {
      return res.isSuccess ? new Date(res.body.FullDate) : new Date();
    });
  }
}
